(function () {
  'use strict';

  var form = document.querySelector('.contact-form__form');
  if (!form) return;

  var queryTypeSelect = form.querySelector('[data-query-select]');
  var conditionalGroups = toArray(form.querySelectorAll('[data-conditional-field]'));
  var typeNotes = toArray(form.querySelectorAll('[data-type-note]'));
  var placeholderSelects = toArray(form.querySelectorAll('[data-placeholder-select]'));
  var errorBanner = form.querySelector('[data-error-summary]');
  var errorSummaryTitle = errorBanner ? errorBanner.querySelector('[data-error-summary-title]') : null;
  var errorSummaryList = errorBanner ? errorBanner.querySelector('[data-error-summary-list]') : null;

  var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var PHONE_PATTERN = /^[0-9+\-\s()]+$/;
  var PHONE_MIN_DIGITS = 6;

  // Every [data-contact-field] input. Whether a field is validated is decided at validation
  // time (see isActive), so conditional fields drop in and out without re-registering.
  var fields = toArray(form.querySelectorAll('[data-contact-field]')).map(function (input) {
    return {
      input: input,
      error: document.getElementById(input.getAttribute('data-error-id')),
      message: input.getAttribute('data-error-message') || 'Please check this field.'
    };
  });

  function toArray(list) {
    return Array.prototype.slice.call(list);
  }

  function announce(message) {
    if (typeof announceToScreenReader === 'function') {
      announceToScreenReader(message);
    }
  }

  /* ------------------------------------------------------------
     Conditional fields
     ------------------------------------------------------------ */

  function getSelectedOption() {
    if (!queryTypeSelect || !queryTypeSelect.value) return null;
    return queryTypeSelect.options[queryTypeSelect.selectedIndex];
  }

  function clearFieldError(field) {
    field.input.removeAttribute('aria-invalid');
    if (field.error) {
      field.error.textContent = '';
      field.error.hidden = true;
    }
  }

  // Hidden groups are also disabled: removed from the tab order, skipped by validation, and
  // left out of FormData so the merchant's email only lists fields relevant to the enquiry.
  // Values are kept, so switching type and back doesn't lose what the customer typed.
  function setGroupVisible(group, show) {
    group.hidden = !show;
    toArray(group.querySelectorAll('input, textarea, select')).forEach(function (el) {
      el.disabled = !show;
    });

    if (!show) {
      fields.forEach(function (field) {
        if (group.contains(field.input)) clearFieldError(field);
      });
    }
  }

  function syncPlaceholder(select) {
    select.classList.toggle('is-placeholder', select.value === '');
  }

  function syncQueryState() {
    if (!queryTypeSelect) return;

    var option = getSelectedOption();
    var visibleFields = option ? (option.getAttribute('data-fields') || '').split(/\s+/) : [];
    var noteId = option ? option.getAttribute('data-note-id') : null;

    conditionalGroups.forEach(function (group) {
      setGroupVisible(group, visibleFields.indexOf(group.getAttribute('data-conditional-field')) !== -1);
    });

    typeNotes.forEach(function (note) {
      note.hidden = note.id !== noteId;
    });

    // Point the select at the active note so it's read alongside the select on focus.
    var describedBy = [queryTypeSelect.getAttribute('data-error-id')];
    if (noteId) describedBy.push(noteId);
    queryTypeSelect.setAttribute('aria-describedby', describedBy.join(' '));

    syncPlaceholder(queryTypeSelect);
  }

  function announceQueryChange() {
    var option = getSelectedOption();
    if (!option) return;

    var message = option.textContent.trim() + ' selected. The form fields below have been updated.';
    var noteId = option.getAttribute('data-note-id');
    var note = noteId ? document.getElementById(noteId) : null;
    if (note) message += ' ' + note.textContent.trim();

    announce(message);
  }

  if (queryTypeSelect) {
    queryTypeSelect.addEventListener('change', function () {
      syncQueryState();
      announceQueryChange();
    });
  }

  placeholderSelects.forEach(function (select) {
    if (select === queryTypeSelect) return;
    select.addEventListener('change', function () {
      syncPlaceholder(select);
    });
  });

  /* ------------------------------------------------------------
     Validation
     ------------------------------------------------------------ */

  function isActive(field) {
    return !field.input.disabled && !field.input.closest('[hidden]');
  }

  function isValueValid(input, val) {
    if (!val) return !input.required;
    if (input.type === 'email') return EMAIL_PATTERN.test(val);
    if (input.type === 'tel') {
      return PHONE_PATTERN.test(val) && val.replace(/\D/g, '').length >= PHONE_MIN_DIGITS;
    }
    return true;
  }

  // Error spans are linked to their input by aria-describedby rather than being live regions,
  // so a failed submit doesn't fire one alert per field. `announceError` is set for blur
  // validation, where focus has already moved on and the error would otherwise go unheard.
  function validateField(field, announceError) {
    if (!isActive(field)) {
      clearFieldError(field);
      return true;
    }

    var valid = isValueValid(field.input, field.input.value.trim());
    var wasInvalid = field.input.getAttribute('aria-invalid') === 'true';

    if (valid) {
      clearFieldError(field);
    } else {
      field.input.setAttribute('aria-invalid', 'true');
      if (field.error) {
        field.error.textContent = field.message;
        field.error.hidden = false;
      }
      if (announceError && !wasInvalid) announce(field.message);
    }

    return valid;
  }

  // Lists each invalid field as a link to it, then takes focus so the whole summary is read.
  function renderErrorSummary(invalid) {
    if (!errorBanner) return;

    if (errorSummaryTitle) {
      errorSummaryTitle.textContent =
        invalid.length === 1
          ? 'There is 1 problem with your enquiry.'
          : invalid.length > 1
            ? 'There are ' + invalid.length + ' problems with your enquiry.'
            : 'There is a problem with your enquiry.';
    }

    if (errorSummaryList) {
      errorSummaryList.textContent = '';
      invalid.forEach(function (field) {
        var item = document.createElement('li');
        var link = document.createElement('a');
        link.href = '#' + field.input.id;
        link.textContent = (field.error && field.error.textContent.trim()) || field.message;
        link.addEventListener('click', function (e) {
          e.preventDefault();
          field.input.focus();
        });
        item.appendChild(link);
        errorSummaryList.appendChild(item);
      });
      errorSummaryList.hidden = invalid.length === 0;
    }

    errorBanner.hidden = false;
    errorBanner.focus();
  }

  function validateAll() {
    var invalid = fields.filter(function (field) {
      return !validateField(field);
    });

    if (invalid.length) {
      renderErrorSummary(invalid);
      return false;
    }

    if (errorBanner) {
      errorBanner.hidden = true;
    }

    return true;
  }

  fields.forEach(function (field) {
    var input = field.input;
    var isSelect = input.tagName === 'SELECT';

    if (isSelect) {
      input.addEventListener('change', function () {
        if (input.getAttribute('aria-invalid') === 'true') validateField(field);
      });
      return;
    }

    input.addEventListener('blur', function () {
      if (input.value.trim().length > 0 || input.getAttribute('aria-invalid') === 'true') {
        validateField(field, true);
      }
    });

    input.addEventListener('input', function () {
      if (input.getAttribute('aria-invalid') === 'true') {
        validateField(field);
      }
    });
  });

  /* ------------------------------------------------------------
     Submission
     ------------------------------------------------------------ */

  // Shopify owns the native POST and its CAPTCHA challenge/retry lifecycle.
  // An AJAX fetch from captcha.protect's ready callback can submit before a
  // challenge token is available. Only stop submission for local validation;
  // leave the controls enabled so Shopify can serialize and submit the form.
  form.addEventListener('submit', function (event) {
    if (!validateAll()) {
      event.preventDefault();
    }
  });

  function onReady(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  onReady(function () {
    form.setAttribute('data-shopify-captcha', 'true');

    var serverSuccess = form.querySelector('.contact-form__success--visible');
    if (serverSuccess) {
      serverSuccess.focus({ preventScroll: true });

      function centerSuccess() {
        // Run after the native form-fragment jump and page layout have settled.
        window.requestAnimationFrame(function () {
          // On tall/mobile screens the message can be above the viewport centre
          // even at scroll zero. Add only the success-state space it needs.
          var inner = form.closest('.contact-form__inner');
          if (inner) {
            inner.style.paddingTop = '';
            var rect = serverSuccess.getBoundingClientRect();
            var centre = window.scrollY + rect.top + rect.height / 2;
            inner.style.paddingTop = Math.max(0, window.innerHeight / 2 - centre) + 'px';
          }
          serverSuccess.scrollIntoView({ block: 'center', behavior: 'instant' });
        });
      }

      if (document.readyState === 'complete') {
        centerSuccess();
      } else {
        window.addEventListener('load', centerSuccess, { once: true });
      }
      return;
    }

    // Restores the right fields if the browser kept the selection (back/forward cache, reload).
    syncQueryState();
    placeholderSelects.forEach(syncPlaceholder);

    // Non-AJAX fallback: Shopify re-rendered the page with errors (in practice, the email).
    if (errorBanner && !errorBanner.hidden) {
      renderErrorSummary(
        fields.filter(function (field) {
          return field.input.getAttribute('aria-invalid') === 'true';
        })
      );
    }
  });
})();
